export const PickAndChooseCtaState = {
  Select: 'select',
  Edit: 'edit',
  Zero: 'zero'
};
//# sourceMappingURL=models.js.map